<div class="flex-col height100p">
    <sm-toolbar>
        <input #evaluateTextComponent pInputText class="monospace flex-grow" type="text" name="evaluateText" [(ngModel)]="evaluateText" (keypress)="keyPress($event)"/>
        <button pButton icon="fas fa-check" label="Eingabe auswerten" (click)="evaluateInput()"></button>
        <button pButton icon="fas fa-check" label="Selektion auswerten" (click)="evaluateSelection()"></button>
        <button pButton icon="fas fa-check" label="Alles auswerten" (click)="evaluateAll()"></button>
        <button pButton icon="fas fa-check" label="AST Debug" (click)="astDebug()"></button>
        <input *ngIf="guid != null" pInputText type="text" name="objectIndex" placeholder="Objekt Index" [pTooltip]="'Hier kann eine Objekt-ID eingegeben werden, auf der die Auswertung stattfinden soll. Leerlassen für aktuelle Metadaten'" [(ngModel)]="objectIndex"/>
    </sm-toolbar>
    <div *ngIf="errorMessage != null" class="monospace p-3 xbg-red-300" style="white-space: pre-wrap;" [innerHTML]="errorMessage"></div>
    <div class="flex-item-fill flex-row-split">
        <p-panel *ngIf="guid == null" class="flex-item-fixed width400 full-height" header="Metadaten im JSON-Format">
            <textarea pInputTextarea spellcheck=false class="width100p height100p monospace no-resize" [(ngModel)]="metaData"></textarea>
        </p-panel>
        <p-tabView class="flex-item-fill height100p full-height direct-sub" [(activeIndex)]="tabIndex">
            <p-tabPanel header="Baum">
                <p-treeTable [value]="evaluationTree" class="height100p full-height" [(contextMenuSelection)]="selectedNode">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th>Value</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                        <tr [ttRow]="rowNode" [ttContextMenuRow]="rowNode">
                            <td>
                                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                {{rowData.key}}
                            </td>
                            <td>{{rowData.value}}</td>
                        </tr>
                    </ng-template>
                </p-treeTable>
            </p-tabPanel>
            <p-tabPanel header="Text">
                <textarea pInputTextarea spellcheck=false class="height100p width100p monospace no-resize" [(ngModel)]="evaluationResult"></textarea>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
